import { select as d3_select } from 'd3-selection'

export function ellipse(width = 100, padding = 0) {
  var self = d3_select(this)
  var textLength = self.node().getComputedTextLength()
  var text = self.text()
  this._ellipsed = false
  while (textLength > width - 2 * padding && text.length > 0) {
    text = text.slice(0, -1)
    self.text(text + '...')
    this._ellipsed = true
    textLength = self.node().getComputedTextLength()
    if (text.length < 6) self.text('+')
  }
}
